// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"885c7acc","147":"4fa87963","295":"af49096d","362":"ad0269ad","574":"f344be18","807":"2606a564","818":"35c12887","899":"d7c32131","900":"38f06b08","996":"29f57e51"}[chunkId] + ".chunk.js";
};